import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-3" }
const _hoisted_2 = { class: "flex flex-wrap gap-2" }
const _hoisted_3 = { class: "p-4 border border-gray-200 shadow sm:rounded-lg h-52 overflow-auto relative" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "text-gray-500 mb-4" }
const _hoisted_6 = { class: "flex flex-col gap-y-3" }
const _hoisted_7 = { class: "flex flex-wrap gap-2" }
const _hoisted_8 = { class: "p-4 border border-gray-200 shadow sm:rounded-lg h-52 overflow-auto relative" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "text-gray-500 mb-4" }

import { onMounted, ref, watch, onUnmounted } from "vue"
import { SearchIcon } from "@heroicons/vue/outline"
import GgmsLoading from "@/components/GgmsLoading.vue"
import GgmsCheckBox from "@/components/GgmsCheckBox.vue"
import GgmsChip from "@/components/GgmsChip.vue"
import GgmsInput from "@/components/GgmsInput.vue"
import { debounce, getNotFoundText } from "@/shared/utils/helpers"
import { useWorkflowStore } from "@/stores/workflow"
import { useTagStore } from "@/stores/tag"
import { Tag } from "@/shared/models/tag"
import { NodeType } from "@/shared/models/workflow"


export default /*@__PURE__*/_defineComponent({
  __name: 'ApplyTagsComponent',
  setup(__props) {

const tagStore = useTagStore()
const workflowStore = useWorkflowStore()

const toAddSearch = ref("")
const toRemoveSearch = ref("")

const toAddTags = ref<Tag[]>([])
const toRemoveTags = ref<Tag[]>([])

function getTagClass(tag: Tag) {
    return "mb-4 last:mb-0"
}

function removeTagFromList(tag: Tag, collection: "added" | "removed") {
    if (collection === "added") {
        const index = toAddTags.value.findIndex((t) => t._id === tag._id)
        if (index !== -1) {
            workflowStore.toAdd[index] = false
        }
    } else {
        const index = toRemoveTags.value.findIndex((t) => t._id === tag._id)
        if (index !== -1) {
            workflowStore.toRemove[index] = false
        }
    }
}

onMounted(async () => {
    tagStore.resetTableState()
    tagStore.tableState.typeName = "contact"
    await tagStore.getTags()
    toAddTags.value = tagStore.tableState.data
    toRemoveTags.value = tagStore.tableState.data

    // Initialize toAdd and toRemove arrays based on existing tags
    const currentNode = workflowStore.workflow.nodes.find((node) => node.type === NodeType.tags)
    if (currentNode?.data?.toAdd) {
        workflowStore.toAdd = tagStore.tableState.data.map(
            (tag) => currentNode.data?.toAdd?.some((savedTag) => savedTag._id === tag._id) ?? false
        )
    } else {
        workflowStore.toAdd = new Array(tagStore.tableState.data.length).fill(false)
    }

    if (currentNode?.data?.toRemove) {
        workflowStore.toRemove = tagStore.tableState.data.map(
            (tag) => currentNode.data?.toRemove?.some((savedTag) => savedTag._id === tag._id) ?? false
        )
    } else {
        workflowStore.toRemove = new Array(tagStore.tableState.data.length).fill(false)
    }
})

onUnmounted(() => {
    tagStore.resetTableState()
})

watch(
    () => [workflowStore.toAdd, workflowStore.toRemove],
    () => {
        workflowStore.areButtonDisabled =
            !workflowStore.toAdd.filter((isSelected: boolean) => isSelected).length &&
            !workflowStore.toRemove.filter((isSelected: boolean) => isSelected).length
    },
    { deep: true }
)

watch(
    () => toAddSearch.value,
    debounce(async () => {
        if (toAddSearch.value) {
            const tags = await tagStore.getAllTagsBySearch(toAddSearch.value)
            toAddTags.value = tags || []
        } else {
            toAddTags.value = tagStore.tableState.data
        }
    }, 250)
)

watch(
    () => toRemoveSearch.value,
    debounce(async () => {
        if (toRemoveSearch.value) {
            const tags = await tagStore.getAllTagsBySearch(toRemoveSearch.value)
            toRemoveTags.value = tags || []
        } else {
            toRemoveTags.value = tagStore.tableState.data
        }
    }, 250)
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-gray-900 text-lg leading-6 font-medium" }, "Add tags", -1)),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toAddTags.value?.filter((tag, i) => _unref(workflowStore).toAdd[i]), (tag) => {
          return (_openBlock(), _createBlock(GgmsChip, {
            class: "h-6 mx-1",
            key: tag._id,
            bgColor: tag.backgroundColor,
            textColor: tag.foregroundColor,
            onOnRemove: ($event: any) => (removeTagFromList(tag, 'added'))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(tag.displayName), 1)
            ]),
            _: 2
          }, 1032, ["bgColor", "textColor", "onOnRemove"]))
        }), 128))
      ]),
      _createVNode(GgmsInput, {
        modelValue: toAddSearch.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((toAddSearch).value = $event)),
        placeholder: "Search values",
        iconStart: _unref(SearchIcon)
      }, null, 8, ["modelValue", "iconStart"]),
      _createElementVNode("div", _hoisted_3, [
        (_unref(tagStore).tableState.isLoading)
          ? (_openBlock(), _createBlock(GgmsLoading, { key: 0 }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toAddTags.value, (tag, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: tag._id,
                  class: _normalizeClass(["flex items-center", getTagClass(tag)])
                }, [
                  _createVNode(GgmsCheckBox, {
                    modelValue: _unref(workflowStore).toAdd[i],
                    "onUpdate:modelValue": ($event: any) => ((_unref(workflowStore).toAdd[i]) = $event),
                    classes: ['mr-3']
                  }, {
                    default: _withCtx(() => [
                      _createVNode(GgmsChip, {
                        bgColor: tag.backgroundColor,
                        textColor: tag.foregroundColor,
                        isRemovable: false
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(tag.displayName), 1)
                        ]),
                        _: 2
                      }, 1032, ["bgColor", "textColor"])
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue"])
                ], 2))
              }), 128)),
              (!toAddTags.value?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(getNotFoundText)("tags", _unref(tagStore).tableState.search)), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
      ])
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("hr", { class: "bg-gray-200 w-[445px] -mx-6 mt-5 mb-4" }, null, -1)),
    _createElementVNode("div", _hoisted_6, [
      _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-gray-900 text-lg leading-6 font-medium" }, "Remove tags", -1)),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toRemoveTags.value?.filter((tag, i) => _unref(workflowStore).toRemove[i]), (tag) => {
          return (_openBlock(), _createBlock(GgmsChip, {
            class: "h-6 mx-1",
            key: tag._id,
            bgColor: tag.backgroundColor,
            textColor: tag.foregroundColor,
            onOnRemove: ($event: any) => (removeTagFromList(tag, 'removed'))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(tag.displayName), 1)
            ]),
            _: 2
          }, 1032, ["bgColor", "textColor", "onOnRemove"]))
        }), 128))
      ]),
      _createVNode(GgmsInput, {
        modelValue: toRemoveSearch.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((toRemoveSearch).value = $event)),
        placeholder: "Search values",
        iconStart: _unref(SearchIcon)
      }, null, 8, ["modelValue", "iconStart"]),
      _createElementVNode("div", _hoisted_8, [
        (_unref(tagStore).tableState.isLoading)
          ? (_openBlock(), _createBlock(GgmsLoading, { key: 0 }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toRemoveTags.value, (tag, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: tag._id,
                  class: _normalizeClass(["flex items-center", getTagClass(tag)])
                }, [
                  _createVNode(GgmsCheckBox, {
                    modelValue: _unref(workflowStore).toRemove[i],
                    "onUpdate:modelValue": ($event: any) => ((_unref(workflowStore).toRemove[i]) = $event),
                    classes: ['mr-3']
                  }, {
                    default: _withCtx(() => [
                      _createVNode(GgmsChip, {
                        bgColor: tag.backgroundColor,
                        textColor: tag.foregroundColor,
                        isRemovable: false
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(tag.displayName), 1)
                        ]),
                        _: 2
                      }, 1032, ["bgColor", "textColor"])
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue"])
                ], 2))
              }), 128)),
              (!toRemoveTags.value?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(getNotFoundText)("tags", _unref(tagStore).tableState.search)), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
      ])
    ])
  ], 64))
}
}

})